// extracted by mini-css-extract-plugin
module.exports =  {"container":"sXeenWIjkW1rLsdHjDBN","containerWide":"iwa4HcNSXMfW1KekhRXK","editor":"pZ7Tfvc9RjJa2sJweuww"};